type ResponseType = "choice" | "multichoice" | "text" | "multitext";

export interface Question<T = unknown, S = unknown> {
  type: ResponseType;
  statement: S;
  getValue(answer: Answer): T | undefined;
}

export type Response = {
  type: ResponseType;
};

export type Answer<T extends Response = Response> = {
  response: T;
};

export class Answers {
  items: Map<Question, Answer>;

  constructor(entries: [Question, Answer][] = []) {
    this.items = new Map(entries);
  }

  get(question: Question) {
    return this.items.get(question);
  }

  lookup<T>(question: Question<T>): T | undefined {
    const answer = this.items.get(question);
    if (!answer) {
      return undefined;
    }
    return question.getValue(answer);
  }

  set(question: Question, answer: Answer) {
    const entries = Array.from(this.items.entries());
    entries.push([question, answer]);
    return new Answers(entries);
  }

  remove(question: Question) {
    const entries = Array.from(this.items.entries()).filter(([q]) => {
      return q !== question;
    });

    return new Answers(entries);
  }
}
